import LocalizedClientLink from "@/components/molecules/LocalizedLink/LocalizedLink"
import { CollapseIcon } from "@/icons"
import { SellerInfo } from "@/components/molecules"
import { SellerProps } from "@/types/seller"

export const ProductDetailsSeller = ({ seller }: { seller?: SellerProps }) => {
  if (!seller) return null

  return (
    <div className="border-t border-gray-200 overflow-hidden hover:border-gray-300 transition-colors">
      <div className="py-4">
        <LocalizedClientLink href={`/sellers/${seller.handle}`}>
          <div className="flex justify-between items-center">
            <SellerInfo seller={seller} />
            <CollapseIcon className="-rotate-90 shrink-0" />
          </div>
        </LocalizedClientLink>
      </div>
    </div>
  )
}
